import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../customTable';
import axios from 'axios';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import _ from 'lodash';

const ByProdId = ({setActiveStep ,options,setOptions,dateLimit,setDateLimit , rowData}) => {
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [prodData , setProdDada] = useState([])
    const dispatch = useDispatch()
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "docdate",
            headerName: "Doc Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "code",
            headerName: "Product Code",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "item",
            headerName: "Product Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "qty",
            headerName: "Qty",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "amt",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
    ]
    const rows = _.map(prodData,(val,idx)=>({
        id: idx+1,
        sno: idx+1,
        docdate:val.docdate,
        code : val.pro_code,
        item : val.pro_name,
        qty : val.qty,
        amt : parseFloat(val.amount).toFixed(2),
      }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      const getProdId = () => {
        const getProduct = {
            from_date: moment(dateLimit.fromDate).format('YYYY-MM-DD'),
            to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
            customer: options.customer !==null ? options.customer.id : 0,
            category: options.category !==null ? options.category.id : 0,
            subcategory: options.subCategory !==null ? options.subCategory.id : 0,
            prodid:rowData && rowData.id
        }
        axios.post(`/v1/reports/outlet_sales/itemwise/breakups/byprodid`,getProduct)
        .then((res) => {
            console.log(res)
            setProdDada(res.data)
            setPageCount(res.data.length)
        })
        .catch((err) => {
            console.log(err)
            setProdDada([])
            dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
        })
      }
      useEffect(() => {
        getProdId()
      },[options,dateLimit,rowData])
      console.log(rowData && rowData.id)
    return (
    <Grid>
        <Grid className='text-end'>
            <Button variant="contained" onClick={() => setActiveStep("0")}>Back</Button>
        </Grid>
        <CustomTable props={props}/>
    </Grid>
  )
}

export default ByProdId